import * as enums from "./enums";
import * as utils from "./utils";
import {bookingConditions} from "./bookingConditions";

const QuoteService = {
    enums,
    utils,
    bookingConditions
};

export default QuoteService;